import CloseIcon from '@mui/icons-material/Close';

const MaterialCloseIcon = (props) => {
  return <CloseIcon htmlColor={props.color || '#1A1A1A'} />;
};

export default MaterialCloseIcon;
